export const archive = {
    page_title: "Archivo de Documentos",
    upload_per_cent_done: "hecho",
    all_upload_done: "Todos los archivos subidos",
    select_file_type: "Elija la categoría de archivo...",
    go_back_to_list: "Volver a la lista",
    upload_failed: "File upload failed",
    upload_failed_message: "Failed to upload file named <fileName>",
    upload_failed_message_retry: "Try uploading the file one more time",
    upload_hint: "Arrastre y suelte o haga clic para agregar un archivo",
    upload_limits: "PDF, XML, DOCX. Max <maxFileSize>",
    show_deleted: "Mostrar archivos eliminados",
    insurance_title: "¿Interesado en ahorrar en seguros?",
    insurance_advantages: "Podemos ahorrarle al edificio los costos del seguro y aun así mantener el alcance de la cobertura",
    insurance_conditions: "Con el fin de recibir una cotización atractiva para la renovación de una póliza de seguro de hogar, autorizo a la compañía Blink a transferir los documentos de la póliza y los datos de contacto conmigo a Gor Insurance Group y autorizo a los representantes de Gor Insurance Group a que se comuniquen conmigo con respecto al asunto.",
    insurance_disagree: "No gracias, continuemos.",
    insurance_confirm: "Confirmar",
    delete_confirm: {
        title: "Eliminar un archivo del archivo",
        question: "Justo antes de que eliminemos el archivo por completo... ¿Está seguro de que desea realizar la acción?",
    },
    file_actions: {
        delete: 'Borrar',
        undelete: 'Recuperar',
    },
    file_type: {
        none: "Sin tipo",
        insurance: "Seguro de construcción",
        managementAgreement: "Acuerdo de gestión",
        supplierAgreement: "Acuerdo de proveedor",
        offer: "Oferta",
        protocol: "Protocolo",
        bllink: "Bllink",
    },
    select_type: "Seleccione un tipo de archivo {{name}}"
};
